<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="$router.go(-1)">
          <a-icon type="rollback" />&nbsp; Return
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              BKM Manifest
              <small class="m-display-block m-text-small">{{
                data.header.no_bkm
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad"
                    >Manifest</a-button
                  >
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc">{{
                    moment(data.header.date_created, getStandartFormatDate).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>                
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc" style="white-space: pre-line;">{{ data.header.description }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Bank Name</span>
                  <span class="m-list-desc">{{
                    data.header.bank_name ? data.header.bank_name : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Bank Account</span>
                  <span class="m-list-desc">{{
                    data.header.bank_account
                  }}</span>
                </li>                
                <li>
                  <span class="m-list-title" for>Total Value</span>
                  <span class="m-list-desc">{{
                    formatCurrency(currency, Number(data.header.total_value))
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Terbilang</span>
                  <span class="m-list-desc"
                    ><i>{{
                      data.header.total_value_terbilang
                    }}</i></span
                  >
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse class="margin-top margin-bottom" activeKey="1" v-model="activeKey">
            <a-collapse-panel key="1">              
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transaction List</h4>               
              </div>
              <a-table
                rowKey="bkm_dtl_id"
                key="bkm_dtl_id"
                id="transd"
                :columns="columns"
                :dataSource="data.transaction_list"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="uploaded ? { x: 1300 } : { x: 650 }"
              >
                <span slot="value" slot-scope="item">
                  <CurrencyJustified
                    :currencyValue="item.currency"
                    :valueNumber="parseFloat(item.value_kurs)"
                  />
                </span>

                <a
                  slot="no_transaksi"
                  slot-scope="item"
                  @click="handleLink(item.jenis_transaksi, item.id_transaksi)"
                  ><b>{{ item.no_transaksi }}</b>
                </a>

                <span slot="tm" slot-scope="item">
                  {{item.no_tm}}
                </span>

                <span slot="kurs" slot-scope="item">
                  <CurrencyJustified
                    :currencyValue="item.currency_from"
                    :valueNumber="parseFloat(item.kurs)"
                  />
                </span>

                <span slot="value_kurs" slot-scope="item">
                  <CurrencyJustified
                    :currencyValue="item.currency_from"
                    :valueNumber="Math.ceil(parseFloat(item.value_kurs))"
                  />
                </span>
              </a-table>              
            </a-collapse-panel>
          </a-collapse>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
          <a-collapse activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <!-- <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button> -->
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.header.tlc_create }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(
                          data.header.date_created,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      }}
                    </h4>
                    <!-- <span
                      class="m-text-small"
                      v-if="data.manifest.catatan"
                    >{{data.manifest.catatan}}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span> -->
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">File Attachment</h4>
                <div>
                  <a-button
                    @click="addLampiran"
                    :disabled="data.file_attachment!=null"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    upload
                    <a-icon type="upload" />
                  </a-button>
                </div>
              </div>
              <a-list itemLayout="horizontal" >
                <Empty v-if="data.file_attachment == null" />
                <!-- <a-list-item>
                  <a-list-item-meta>
                    <div slot="title">
                      <a
                        @click="handleDownload(data.file_attachment_url)"
                        class="margin-remove m-text-dots"
                      >
                        {{ data.file_attachment ? data.file_attachment : "-" }}
                      </a>
                    </div>
                    <!-- <div slot="description">
                      <div>
                        <a-tooltip placement="bottom">
                          <template slot="title">
                            <span>{{ item.file_attachment }}</span>
                          </template>
                          <h4 class="margin-remove m-text-dots">
                            {{ item.file_attachment }}
                          </h4>
                        </a-tooltip>                        
                      </div>
                      {{ item.create_dt }}
                    </div> --
                  </a-list-item-meta>
                </a-list-item> -->
                <a-list-item v-else>
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <h4 class="m-list-dots margin-removes">{{data.file_attachment}}</h4>
                      <a-button
                        size="small"
                        type="default"
                        icon="cloud-download"
                        @click="handleDownload(data.file_attachment_url)"
                      ></a-button>
                    </div>
                    <div slot="avatar" >
                      <a-icon :type="load_icon(data.file_attachment ? 
                        data.file_attachment.substring(data.file_attachment.lastIndexOf('.')+1) 
                          : 'file')" style='font-size: 48px'/>
                    </div>
                    <!-- <img v-if="data.file_attachment_url && data.file_attachment_url.includes('.pdf')" class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" /> -->
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal
      v-model="visibleLampiran"
      @ok="addLampiran"
      :footer="null"
      @cancel="cancelLampiran"
      :width="600"
    >
      <span slot="title">
        <a-icon type="reload" />&nbsp;Upload Attachment
      </span>

      <a-row type="flex" justify="space-between" :gutter="10">
        <a-col :span="24">
          <a-form :form="formLampiran">
            <a-form-item label="Document Name">
              <a-input
                autocomplete="off"
                v-decorator="['document_name', { rules: [{ required: true }] }]"
              ></a-input>
            </a-form-item>

            <a-form-item label="Upload Document File">
              <a-upload
                :showUploadList="true"
                :beforeUpload="beforeUpload"
                :remove="handleRemove"
                v-decorator="[
                  'file_list_lampiran',
                  { rules: [{ required: true }] },
                ]"
                :fileList="fileListLampiran"
              >
                <a-button
                  ref="btndocument"
                  :disabled="fileListLampiran.length > 0"
                  icon="upload"
                  >Select File
                </a-button>
              </a-upload>              
            </a-form-item>            
          </a-form>
        </a-col>       
      </a-row>      
      <a-row type="flex" justify="end" :gutter="10" class="margin-top">
        <a-col :span="4">
          <a-button
            type="danger"
            style="float: right; vertical-align: middle"
            @click="handleUploadLampiran"
            :loading="uploadLoading"
          >
            Save
          </a-button>
        </a-col>
      </a-row>
    </a-modal>    
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "ManifestBKM",
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  data() {
    return {
      data: {
        header: {
          description: "",
          bank_account: "",
          bank_account_id: "",
          bank_name: "",
          bkm_id: "",
          currency: "",
          date_created: "",
          file_name: "",
          no_bkm: "",
          tlc_create: "",
          total_value: 0,
          total_value_terbilang: "",
          value: "",
        },
        transaction_list: [],
      },
      currency: "IDR",
      pageLoading: false,
      uploadLoading: false,
      printLoad: false,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      visibleLampiran: false,
      fileListLampiran: [],
      uploaded: false,
      list_data: [],
      listProcessLoading: false,
      activeKey: ["1"],
      exString: /(?:\.([^.]+))?$/
    };
  },
  created() {},
  beforeCreate() {
    this.formLampiran = this.$form.createForm(this);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();        
      }
    },
  },
  mounted() {
    // Event.$on("confirmMessageReturn", this.handleAction);
    Event.$on("refresh", this.fetchManifest);    
    this.fetchManifest();  
  },
  beforeDestroy() {
    Event.$off("refresh", this.fetchManifest);        
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          dataIndex: "no",
          align: "center",
          key: "no",
          width: 25,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "No",
          width: 150,
          key: "transaksi_no",
          scopedSlots: { customRender: "no_transaksi" },
          sorter: (a, b) => a.no_transaksi.length - b.no_transaksi.length,
        },   
        {
          title: "No TM",
          width: 150,
          key: "tm",
          scopedSlots: { customRender: "tm" },
          sorter: (a, b) => a.no_transaksi.length - b.no_transaksi.length,
        },        
        {
          title: "Description",
          width: 150,
          key: "label_jenis_transaksi",
          dataIndex: "label_jenis_transaksi",
          sorter: (a, b) => a.label_jenis_transaksi.length - b.label_jenis_transaksi.length,
        },
        {
          title: "Value",
          key: "value",
          width: 80,
          scopedSlots: { customRender: "value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        }       
      ];      
      return kolom;
    }    
  },
  methods: {
    moment,          
    async fetchManifest() {
      this.pageLoading = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "bkm",
        params: {
          tlc: this.getAuth.username,
          id_bkm: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          //console.log(response)

          this.data = response.data;
          this.currency = response.data.header.currency;

          if (this.data.transaction_list.length > 0) {
            this.list_data = this.data.transaction_list.filter((value) => {
              if (value.currency !== "IDR") {
                return value;
              }
            });

            if (this.list_data.length > 0) {
              for (let index = 0; index < this.list_data.length; index++) {
                let col = [
                  {
                    ...this.list_data[index],
                    key: index + 1,
                    no: index + 1,
                    value_data: 0,
                    value_real: 0,
                    currency_to:"IDR",
                  },
                ];
                this.list_data[index] = col[0];
              }
            }


            for (
              let index = 0;
              index < this.data.transaction_list.length;
              index++
            ) {
              let col = [
                { ...this.data.transaction_list[index], no: index + 1 },
              ];
              this.data.transaction_list[index] = col[0];
            }
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.data = {};
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    handleLink(jenis, id_) {
      let manifest = "";
      if (jenis == "ar_s") {
        manifest = "account-receive-manifest";
      } else if (jenis == "ar_g") {
        manifest = "account-receive-manifest";
      } else if (jenis == "oi") {
        manifest = "OtherIncomeManifestKeu";
      } else if (jenis == "financing_fk") {
        manifest = "penarikan-financing-manifest";
      } else if (jenis == "financing_fp") {
        manifest = "financing-manifest";
      } else if (jenis == "lk_um_pp") {
        manifest = "lapUmppManifest";
      } else if (jenis == "lk_um_pd") {
        manifest = "manifestLaporanUmpd";
      } else if (jenis == "am") {
        manifest = "AccountMutationManifestKeu";
      } else if (jenis == "guarantee_fund") {
        manifest = "bidBond-manifestKeu";
      } else if(jenis == "bidbond"){
        manifest = "bidBond-manifest";
      } else if (jenis == "bidbond_request") {
        manifest = "bidBondRequest-manifestKeu";
      } else if (jenis == "guarantee_refund") {
        manifest = "guaranteeRefund-manifestKeu";
      } else if (jenis == "pembayaran_piutang") {
        manifest = "pembayaranpiutang-manifest-keu";
      } else if (jenis == "refund_payment") {
        manifest = "RefundPaymentManifestKeu";
      } else if (jenis == "lap_bailout") {
        manifest = "bailoutfundreportManifest";
      } else {
        manifest = "Manifest";
      }

      if (jenis == "ar_s" || jenis =="ar_g"){
        this.$router.push({ name: manifest, params: { 
          id: id_, 
          tab:"release", 
          jns: jenis == "ar_s" ? "Penerimaan_Kontrak" : "Piutang_lain_lain" } });
      }else{
        this.$router.push({ name: manifest, params: { id: id_ } });
      }
      //const route = this.$router.resolve({ name: "bkkManifestKeu", params: { id: id_} })
      //window.open(route.href, '_blank')
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    handleDownload(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },      
    handlePrintManifest() {
      this.printLoad = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "bkm/cetak_bkm",
        responseType: "blob",
        params: {
          id_bkm: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          console.log(response);
          this.printLoad = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad = false;
          this.$router.go(-1);
        });
    },            
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.fileListLampiran.length == 0){
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_bkm", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("document_name", values.document_name);
        formData.append("document_upload", values.file_list_lampiran.file);        

        this.uploadLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "bkm/upload_bkm",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.uploadLoading = false;
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go(0);
          })
          .catch((err) => {
            this.uploadLoading = false;
            console.log("error : " + err);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileListLampiran.push(file);
        return false;
      }
    },
    cancelLampiran() {
      this.fileListLampiran = [];
      this.formLampiran.resetFields();
    },
    handleRemove(file) {
      const index = this.fileListLampiran.indexOf(file);
      const newFileList = this.fileListLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListLampiran = newFileList;
      this.formLampiran.setFieldsValue({
        file_list_lampiran : undefined
      });
    },      
  },
};
</script>